import * as Yup from 'yup';
import { Shape } from '../yup_types';
import { IFundsReserveConfig } from '../../store/merchnts/merchant-interfaces';

export enum FUNDS_RESERVE_CONFIG_FORM_FIELDS {
	NAME = 'name',
	DISPUTE_RATE_START = 'disputeRateMin',
	DISPUTE_RATE_END = 'disputeRateMax',
	RESERVE_RATE = 'reserveRate',
	TYPE = 'type',
	RESERVE_TYPE = 'reserveRateType',
	PERIOD = 'period',
}

export enum FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES {
	NAME = 'Name',
	DISPUTE_RATE_START = 'Dispute rate from (%)',
	DISPUTE_RATE_END = 'Dispute rate to (%)',
	RESERVE_RATE = 'Reserve rate',
	TYPE = 'Type',
	RESERVE_TYPE = 'Reserve type',
	PERIOD = 'Period (in days)',
}

export type FundsReserveConfigFieldsTypes = {
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.NAME]: string,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_START]: string | number,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_END]: string | number,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_RATE]: string | number,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.TYPE]: string | number,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_TYPE]: string | number,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.PERIOD]: string | number,
}

export type FundsReserveConfigFieldsReturnTypes = {
	name: string,
	disputeRateMin: string | number,
	disputeRateMax: string | number,
	reserveRateType: string | number,
	type: string | number,
	reserveRate: number,
	period: number,
	id?: string,
}

export const getFundsReserveConfigDetailsSchema = (): Yup.SchemaOf<FundsReserveConfigFieldsTypes> => Yup.object<Shape<FundsReserveConfigFieldsTypes>>().shape({
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.NAME]: Yup.string()
		.nullable()
		.required('Name start is required'),
		[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_START]: Yup.number()
		.required('Dispute rate start is required')
		// .test('only integer', 'Value is not an integer', (item) => {
		// 	return Number.isInteger(Number(item));
		// })
		.test('less then 100', 'Value must not be bigger than 100', (item) => {
			return Number(item) <= 100;
		})
		.test('positive', 'Value must be positive', (item) => {
			return Number(item) > 0;
		})
		.test('integer or integer with a half', 'Value must be an integer or an integer with a half', (item) => {
			return /^(\d+(\.5)?|\d*\.0)$/.test(String(item));
		}),

	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_END]: Yup.number()
		.required('Dispute rate end is required')
		// .test('only integer', 'Value is not an integer', (item) => {
		// 	return Number.isInteger(Number(item));
		// })
		.test('less then 100', 'Value must not be bigger than 100', (item) => {
			return Number(item) <= 100;
		})
		.test('positive', 'Value must be positive', (item) => {
			return Number(item) > 0;
		})
		.test('integer or integer with a half', 'Value must be an integer or an integer with a half', (item) => {
			return /^(\d+(\.5)?|\d*\.0)$/.test(String(item));
		}),
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_RATE]: Yup.number()
		.required('Reserve rate is required')
		.test('only integer', 'Value is not an integer', (item) => {
			return Number.isInteger(item);
		}),
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.TYPE]: Yup.string()
		.required('Type is required'),
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_TYPE]: Yup.string()
		.required('Reserve type is required'),
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.PERIOD]: Yup.number()
		.required('Period is required')
		.test('only integer', 'Value is not an integer', (item) => {
			return Number.isInteger(Number(item));
		}),
});

export const fundsReserveConfigInitialFields: FundsReserveConfigFieldsTypes = {
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.NAME]: '',
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_START]: '',
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_END]: '',
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_RATE]: '',
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.TYPE]: '',
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_TYPE]: '',
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.PERIOD]: '',
};

export const convertToInitialFundsReserveConfigValues = (data: IFundsReserveConfig): FundsReserveConfigFieldsTypes => ({
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.NAME]: data?.name,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_START]: data?.disputeRateMin,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_END]: data?.disputeRateMax,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_RATE]: data?.reserveRate / 100,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.TYPE]: data?.type,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_TYPE]: data?.reserveRateType,
	[FUNDS_RESERVE_CONFIG_FORM_FIELDS.PERIOD]: data?.period
});

export const getFormattedFundsReserveConfigFields = (formikValues: FundsReserveConfigFieldsTypes): FundsReserveConfigFieldsReturnTypes => ({
	name: formikValues?.[FUNDS_RESERVE_CONFIG_FORM_FIELDS.NAME],
	disputeRateMin: Number(formikValues?.[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_START]),
	disputeRateMax: Number(formikValues?.[FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_END]),
	reserveRate: Number(formikValues?.[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_RATE]) * 100,
	type: formikValues?.[FUNDS_RESERVE_CONFIG_FORM_FIELDS.TYPE],
	reserveRateType: formikValues?.[FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_TYPE],
	period: Number(formikValues?.[FUNDS_RESERVE_CONFIG_FORM_FIELDS.PERIOD])
});

export const getInitialFundsReserveConfigFields = (data: IFundsReserveConfig): FundsReserveConfigFieldsReturnTypes => ({
	name: data?.name,
	disputeRateMin: data?.disputeRateMin,
	disputeRateMax: data?.disputeRateMax,
	reserveRate: data?.reserveRate,
	type: data?.type,
	reserveRateType: data?.reserveRateType,
	period: data?.period
});
